import { motion } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";

const PageHeader = ({ overline, title, accent, description, testid }) => (
  <section className="relative pt-40 pb-20 lg:pt-52 lg:pb-28 overflow-hidden" data-testid={testid}>
    <div className="absolute inset-0 hero-grid-lines" aria-hidden="true" />
    <div
      className="absolute -top-40 right-0 w-[560px] h-[560px] rounded-full bg-royal/10 blur-[140px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <Overline>{overline}</Overline>
      </Reveal>
      <h1 className="mt-6 font-display font-bold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-slate-900 max-w-3xl">
        <span className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          >
            {title} <span className="text-ember">{accent}</span>
          </motion.span>
        </span>
      </h1>
      {description && (
        <Reveal delay={0.15}>
          <p className="mt-8 text-base md:text-lg text-slate-600 max-w-xl leading-relaxed">
            {description}
          </p>
        </Reveal>
      )}
    </div>
  </section>
);

export default PageHeader;
